<template>
  <span class="plv-ia-answer-question-content-duration">
    <form-checkbox
      v-model="innerEnableLimitTime"
      name="enableLimitTime"
    >
      {{ t('plvIA.answerCard.timeLimit') }}
    </form-checkbox>
    <input
      v-show="innerEnableLimitTime"
      v-model="innerDuration"
      type="text"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />
    <span v-show="innerEnableLimitTime">{{ t('plvIA.answerCard.seconds') }}</span>
  </span>
</template>

<script>
import Locale from '@/mixins/locale';
import FormCheckbox from '@/components/form/Checkbox';

export default {
  components: {
    'form-checkbox': FormCheckbox,
  },
  mixins: [Locale],
  props: {
    enableLimitTime: {
      type: Boolean,
      default: false,
    },

    duration: {
      type: [Number, String],
      default: 8,
    }
  },

  computed: {
    innerDuration: {
      get() {
        return this.duration;
      },

      set(val) {
        this.$emit('update:duration', val);
      }
    },

    innerEnableLimitTime: {
      get() {
        return this.enableLimitTime;
      },

      set(val) {
        this.$emit('update:enableLimitTime', val);
      }
    }
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    handleInputFocus(e) {
      const elInput = e.target;
      this.clearTimer();
      this.timer = setInterval(() => {
        this.innerDuration = elInput.value.replace(/[^\d]/g, '').slice(0, 2);
      }, 500);
    },

    handleInputBlur() {
      this.clearTimer();
    }
  }
};
</script>

<style lang="scss">
.plv-ia-answer-question-content-duration {
  margin-left: 14px;
  user-select: none;

  input[type=text] {
    width: 24px;
    line-height: 24px;
    border-radius: 2px;
    border: 1px solid #CFD8DC;
    text-align: center;
  }

  .plv-ia-checkbox > input + label {
    padding-left: 24px;
  }
}
</style>
